<template>
  <div class="header-bar">
    <!-- <sider-trigger @on-change="handleCollpasedChange"></sider-trigger> -->
    <custom-bread-crumb style="margin-left: 30px;"/>
    <div class="custom-content-con">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import customBreadCrumb from './custom-bread-crumb'
import './header-bar.less'
export default {
  name: 'HeaderBar',
  components: {
    customBreadCrumb,
    // siderTrigger
  },
  methods: {
    handleCollpasedChange () {
      this.$store.dispatch('setLeftCollapse') // 折叠菜单
      this.$store.dispatch('handleLeftMenu') // 改变菜单宽度 180->35/35-180
    }
  }
}
</script>
